import BotConditionCard from "./BotConditionCard";
import React from "react";
import {useWatch} from "react-hook-form";
import ReactHookFormCheckbox from "../../input/ReactHookFormCheckbox";
import ReactHookFormRadio from "../../input/ReactHookFormRadio";
import DeviceTypeMultiSelect from "../../campaigns/conditions/DeviceTypeMultiSelect";
import {Add, Delete} from "@mui/icons-material";
import {Box, Button, IconButton} from "@mui/material";

function BotConditionDeviceType(props) {
    const {control, setValue, getValues} = props;

    // Watch the global rules object in real-time
    const rules = useWatch({control, name: "rules"}) || {};
    const deviceTypeData = rules?.deviceType;
    const hasDeviceTypeCondition = !!deviceTypeData;

    const radioConditions = [
        {label: "Is", value: "is", color: "primary"},
        {label: "Is not", value: "isNot", color: "error"},
    ];

    // REMOVE: Safe JS delete approach
    const removeCondition = () => {
        const currentRules = {...getValues("rules")};
        delete currentRules.deviceType;
        setValue("rules", currentRules);
    };

    // ADD: Initialize flat deviceType object
    const addCondition = () => {
        setValue("rules.deviceType", {
            condition: "is",
            includeEmptyValue: false,
            values: []
        });
    };

    const renderAddCondition = () => {
        if (!hasDeviceTypeCondition) {
            return (
                <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                    <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                        <span>Device type</span>
                    </Box>
                    <Box>
                        <Button
                            aria-label="condition"
                            color="primary"
                            title="Add condition"
                            startIcon={<Add/>}
                            onClick={addCondition}
                            sx={{textTransform: "none", py: 0.25, px: 1}}
                        >
                            Add condition
                        </Button>
                    </Box>
                </Box>
            );
        }
    };

    const renderConditionBox = () => {
        if (hasDeviceTypeCondition) {
            return (
                <>
                    <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                        <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                            Device type
                        </Box>
                        <Box>
                            <IconButton
                                aria-label="remove"
                                color="default"
                                title="Remove"
                                size="small"
                                onClick={removeCondition}
                                sx={{color: 'error.dark'}}
                            >
                                <Delete fontSize="small"/>
                            </IconButton>
                        </Box>
                    </Box>
                    <Box>
                        <ReactHookFormRadio
                            control={control}
                            options={radioConditions}
                            name="rules.deviceType.condition"
                            label="conditions"
                        />
                    </Box>
                    <Box>
                        <ReactHookFormCheckbox
                            control={control}
                            label="Include empty value"
                            labelPlacement="end"
                            name="rules.deviceType.includeEmptyValue"
                        />
                    </Box>
                    <Box sx={{mt: 1}}>
                        <DeviceTypeMultiSelect
                            control={control}
                            inputName="rules.deviceType.values"
                            inputLabel="Device type"
                        />
                    </Box>
                </>
            );
        }
    };

    return (
        <BotConditionCard>
            {renderAddCondition()}
            {renderConditionBox()}
        </BotConditionCard>
    );
}

export default BotConditionDeviceType;
